module.exports = __webpack_public_path__ + "static/img/banner1.fa2aa8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner1.jpg
// module id = 1YA1
// module chunks = 41